<template>
    <el-dialog :title="title" :visible="showDialog" @close="close" width="50%">
        <div class="row">
            <div class="col-md-12">
                <label>Producto</label>
                <el-select v-model="form.item_id" filterable>
                    <el-option
                        v-for="option in items"
                        :key="option.id"
                        :label="`${option.internal_id || ''} - ${option.description}`"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>

            <div class="col-md-12 mt-3">
                <label>Área de producción</label>
                <el-select v-model="form.restaurant_production_area_id" filterable clearable>
                    <el-option
                        v-for="option in productionAreas"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>

            <div class="col-md-6 mt-3">
                <el-switch v-model="form.print_on_kitchen" active-text="Imprime comanda" inactive-text="No imprime"></el-switch>
            </div>

            <div class="col-md-6 mt-3">
                <el-switch v-model="form.active" active-text="Activo" inactive-text="Inactivo"></el-switch>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">Cancelar</el-button>
            <el-button type="primary" @click="submit">Guardar</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['showDialog', 'record'],
    data() {
        return {
            resource: 'restaurant/v2/item-settings',
            form: {},
            items: [],
            productionAreas: [],
        }
    },
    computed: {
        title() {
            return this.form.id ? 'Editar producto por área' : 'Nuevo producto por área'
        },
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.initForm()
                this.getTables()
            }
        },
    },
    methods: {
        initForm() {
            this.form = this.record
                ? {
                    id: this.record.id,
                    item_id: this.record.item_id,
                    restaurant_production_area_id: this.record.restaurant_production_area_id,
                    print_on_kitchen: !!this.record.print_on_kitchen,
                    active: !!this.record.active,
                }
                : {
                    id: null,
                    item_id: null,
                    restaurant_production_area_id: null,
                    print_on_kitchen: true,
                    active: true,
                }
        },
        getTables() {
            this.$http.get(`/${this.resource}/tables`).then(response => {
                this.items = response.data.items
                this.productionAreas = response.data.production_areas
            })
        },
        close() {
            this.$emit('update:showDialog', false)
        },
        submit() {
            this.$http.post(`/${this.resource}`, this.form).then(response => {
                this.$message.success(response.data.message)
                this.$emit('saved')
                this.close()
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/item_settings/form.vue